import React, { useState } from "react";
import NumPad from "react-numpad";
import NumberPad from "./numberPad";
import { useAppGuestUserIdSelector } from "src/_common/hooks/selectors/userSelector";
import { CRYPTO_SECRET_KEY } from "src/_config";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppEventGameDetailSelector } from "src/_common/hooks/selectors/eventSelector";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

const TieBreaker = ({ showUserAnswersList }: any) => {
  const [showNumberPad, setShowNumberPad] = useState(false);
  const [value, setValue] = useState("");
  const pointPlaceholder: any = { "1": "________", "0.1": "_____ . __", "0.01": "____ . ___" };
  const { eventId, performanceId, gameId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  const p_id: number = parseInt(cryptr.decrypt(performanceId));
  const g_id: number = parseInt(cryptr.decrypt(gameId));
  const guestUserId = useAppGuestUserIdSelector();
  const eventApi = useEventApi();
  const eventGameDetailsSelector = useAppEventGameDetailSelector();
  const pointType: any = eventGameDetailsSelector?.events?.point_type;
  const eventAction = useAppEventAction();

  const openNumberPad = () => {
    setShowNumberPad(true);
  };

  const closeNumberPad = (val: any) => {
    if (pointType == "0.1") {
      if (val && !val.includes(".")) {
        val = val + ".0";
      } else {
        const decimal = val.split(".")[1];
        if (decimal?.length == 0) {
          val = val + "0";
        }
      }
    }
    if (pointType == "0.01") {
      if (!val.includes(".")) {
        val = val + ".00";
      } else {
        const decimal = val.split(".")[1];
        if (decimal?.length == 1) {
          val = val + "0";
        }
      }
    }
    setValue(val);
    setShowNumberPad(false);
  };

  const submitTieBreakerCode = () => {
    if (!value) {
      toast.error("Please enter the score");
      return;
    }
    let params: any = {
      rodeo_event_event_id: g_id,
      rodeo_event_id: e_id,
      performance_id: p_id,
      code: value,
    };
    if (guestUserId) {
      params["guest_user_id"] = guestUserId;
    }
    console.log("submitTieBreakerCode");
    eventApi.callSaveTieBreakerCode(
      params,
      (message: any) => {
        toast.success(message);
        eventAction.updateEventDetailsTieBreakerCode(value);
        showUserAnswersList();
      },
      (message: any) => {
        toast.error(message);
      }
    );
  };

  return (
    <>
      <div className="score-fld mb-4">
        <div className="emoji-icon">
          <img src="/images/coins-1.svg" />
        </div>
        <div className="score-input-fld flex-grow-1">
          <input type="text" className="form-control" placeholder="Tie Breaker" />
        </div>
      </div>
      <p className="mb-4 text-blue-cstm">Guess the probability and win points!</p>
      <h3 className="section-heading mb-3">Guess the score of the first qualified time?</h3>
      <div className="score-points-textarea d-flex justify-content-center">
        <label onClick={openNumberPad} className="tie-breaker-label">
          {value || pointPlaceholder[pointType]}
        </label>
        <NumberPad
          show={showNumberPad}
          onClose={closeNumberPad}
          pointType={pointType}
          val={value}
          // pointType={"0.01"}
        />
      </div>
      <div className="d-flex justify-content-center mb-4">
        <button className="btn btn-primary theme-primary-btn" onClick={submitTieBreakerCode}>
          Submit
        </button>
      </div>
    </>
  );
};

export default TieBreaker;
